import { getMarket } from '../modules/i18n';
import type { JbArticleRow } from '@bjb/bjb-web-components/dist/components/jb-article-row/jb-article-row';

const NO_MARKET = 0;

function appliesToMarket(card: Element, market: number): boolean {
  const onlyMarkets = card.getAttribute('data-only-markets');
  if (!onlyMarkets) {
    return true;
  }
  return onlyMarkets.split(',').some((marketUid) => parseInt(marketUid.trim(), 10) === market);
}

export function selectCards<T extends Element>(cards: Array<T>, market: number): { shown: Array<T>; removed: Array<T> } {
  const places = cards.filter((card) => !card.hasAttribute('data-only-markets')).length;
  const applicable = cards.filter((card) => appliesToMarket(card, market));
  const shown = places > 0 ? applicable.slice(0, places) : applicable;

  return {
    shown,
    removed: cards.filter((card) => !shown.includes(card)),
  };
}

function cardsOf(teaserBlock: Element): Array<HTMLElement> {
  return [...teaserBlock.querySelectorAll<HTMLElement>(':scope > jb-article-card')];
}

export function hideRegionalCards(cards: Array<HTMLElement>): void {
  cards.filter((card) => card.hasAttribute('data-only-markets')).forEach((card) => card.style.setProperty('display', 'none'));
}

export function holdPlaces(cards: Array<HTMLElement>, market: number): void {
  const { shown, removed } = selectCards(cards, market);
  // Only the regional cards were hidden here; a global card's display is someone else's to set.
  shown.filter((card) => card.hasAttribute('data-only-markets')).forEach((card) => card.style.removeProperty('display'));
  removed.forEach((card) => card.remove());
}

window.addEventListener('DOMContentLoaded', async () => {
  const teaserBlocks = [...document.querySelectorAll('jb-teaser-block')].map(cardsOf).filter((cards) => cards.length > 0);
  const articleRows = [...document.querySelectorAll<JbArticleRow & HTMLElement>('jb-article-row')];

  teaserBlocks.forEach(hideRegionalCards);
  articleRows.forEach((articleRow) => {
    articleRow.market = NO_MARKET;
  });

  const currentMarket = parseInt(await getMarket(), 10) || NO_MARKET;

  teaserBlocks.forEach((cards) => holdPlaces(cards, currentMarket));
  articleRows.forEach((articleRow) => {
    articleRow.market = currentMarket;
  });
});
